module.exports = __webpack_public_path__ + "static/media/Ladybug Girl.996badbd.jpg";